import { deleteJson, getJson, patchJson, postJson } from './client'
import type { AccountsView, AccountPlanView, ExpansionsView, PriorWorkView, RoadmapPatch, RoadmapView } from '../types/accounts'

// Account planning: companies as accounts, the full plan for one account, and the roadmap of rounds planned next.
const accounts = (spoke: string) => `/api/spokes/${encodeURIComponent(spoke)}/scout/accounts`
const roadmap = (spoke: string, companyId: string) => `${accounts(spoke)}/${encodeURIComponent(companyId)}/roadmap`

export const accountsApi = {
  list: (spoke: string) => getJson<AccountsView>(accounts(spoke)),
  get: (spoke: string, companyId: string) => getJson<AccountPlanView>(`${accounts(spoke)}/${encodeURIComponent(companyId)}`),
  expand: (spoke: string) => getJson<ExpansionsView>(`${accounts(spoke)}/expand`),
  /** What the firm has done that is like this account (REQ-080): won or delivered work, ranked by likeness. */
  priorWork: (spoke: string, companyId: string) => getJson<PriorWorkView>(`${accounts(spoke)}/${encodeURIComponent(companyId)}/prior-work`),
  roadmap: (spoke: string, companyId: string) => getJson<RoadmapView>(roadmap(spoke, companyId)),
  /** Lays out (or refreshes) Scout's proposal. A round a person holds is never written over. */
  proposeRoadmap: (spoke: string, companyId: string) => postJson<RoadmapView>(roadmap(spoke, companyId)),
  patchRoadmap: (spoke: string, companyId: string, itemId: string, patch: RoadmapPatch) =>
    patchJson<RoadmapView>(`${roadmap(spoke, companyId)}/${encodeURIComponent(itemId)}`, patch),
  dropRoadmap: (spoke: string, companyId: string, itemId: string) =>
    deleteJson<RoadmapView>(`${roadmap(spoke, companyId)}/${encodeURIComponent(itemId)}`),
}
